import { useMutation } from 'query';
import { requestMagicLink } from '../../services';

type Variables = {
  email: string;
  referrer?: string;
};

export const useRequestMagicLinkMutation = () =>
  useMutation<undefined, Variables>({
    async mutationFn(data: Variables) {
      await requestMagicLink({
        body: {
          email: data.email,
          redirect_url: data.referrer ? window.origin + data.referrer : undefined,
        },
      });

      return undefined;
    },
  });
